import { CompanyProfile } from '@mkp/company/models';
import { AccountMembership } from '@mkp/account-membership/models';
import { Account } from '@mkp/account/models';
import { createActionGroup, props } from '@ngrx/store';

interface RefreshAccountMembershipsPayload {
  accountMemberships: AccountMembership[];
  totalCount: number;
}

export interface RefreshAccountAggregatePayload {
  accounts: Account[];
  accountMembershipsPayload: RefreshAccountMembershipsPayload;
  companyProfiles: CompanyProfile[];
}

export const accountAggregateApiActions = createActionGroup({
  source: 'Account Aggregate Api',
  events: {
    'Refresh On Permission Check Success': props<RefreshAccountAggregatePayload>(),
    'Refresh On Permission Check Failure': props<{ error: unknown }>(),
    'Refresh On Redeem Invite Success': props<RefreshAccountAggregatePayload>(),
    'Refresh On Redeem Invite Failure': props<{ error: unknown }>(),
  },
});
